import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { TooltipModal } from '$partials/ui/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const richText = ({
    description = null,
    errors = null,
    id = null,
    isDirty = null,
    name = null,
    register = null,
    required = null
}) => {
    // misc
    const {
        ref: rhfRefFunc,
        ...restRhfProps
    } = register(id, { required: required ? 'Please complete this field.' : false } );

    // references
    const localRef = useRef();

    // state
    const [ localValue, setLocalValue ] = useState();

    // hooks
    useEffect(() => {
        if (localRef?.current) {
            localRef.current.style.height = '0px';
            const scrollHeight = localRef.current.scrollHeight;
            localRef.current.style.height = scrollHeight + 'px';
        }
    }, [ localRef, localValue ]);

    // render
    return (
        <div>
            <div className={`form-input form-input--textarea${isDirty ? ' form-input--dirty' : ''}`}>
                <label
                    className='form-input__label'
                    htmlFor={`frm-${id}`}>
                    <span>
                        {name} {required ? <sup>*</sup> : ''}
                    </span>

                    {(description && name) && (
                        <TooltipModal
                            description={description}
                            heading={name} />
                    )}
                </label>

                <textarea
                    className='form-input__input'
                    id={`frm-${id}`}
                    name={id}
                    onKeyUp={e => setLocalValue(e.target.value)}
                    ref={(r) => {
                        rhfRefFunc(r);
                        localRef.current = r;
                    }}
                    required={required}
                    {...restRhfProps} />
            </div>

            {(errors?.message) && (
                <p className='type-style-5 mt-10 text-charcoal'>
                    {errors.message}
                </p>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    isDirty: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    register: PropTypes.func.isRequired,
    required: PropTypes.bool
};

richText.propTypes = propTypes;

export default richText;
